import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useCustomerCategoryStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const CustomerCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable screen="client" recordType="status" />
      <CategoryStatusTable screen="client" recordType="category" />
    </Styles>
  );
};

const CustomerCategoryStatus: FC<ReceivedProps> = (props) => (
  <CustomerCategoryStatusLayout {...useCustomerCategoryStatus(props)} />
);

export default CustomerCategoryStatus;
